export const messages = {
  en: {
    route: {
      search: {
        title: 'Search Condition',
        appId: 'appId',
        serviceName: 'serviceName',
        serviceCode: 'serviceCode',
        placeholder: 'Please enter route name'
      },
      list: {
        title: 'route'
      },
      dialog: {
        addTitle: 'Add Route',
        editTitle: 'Edit Route',
        delTitle: 'Delete Route',
        cancel: 'Cancel',
        confirm: 'Confirm'
      },
      form: {
        id: 'id',
        appId: 'appId',
        serviceId: 'serviceId',
        orderTypeCd: 'orderTypeCd',
      },
      table: {
        id: 'id',
        appId: 'appId',
        serviceId: 'serviceId',
        serviceCode: 'serviceCode',
        serviceName: 'serviceName',
        appName: 'appName',
        orderTypeCd: 'orderTypeCd',
      },
      validate: {
        id: 'Please enter id',
        appId: 'Please enter appId',
        serviceId: 'Please enter serviceId',
        orderTypeCd: 'Please enter orderTypeCd',
      },
      register:'register',
      add: {
        success: 'Add Route success'
      },
      edit: {
        success: 'Edit Route success'
      },
      delete: {
        success: 'Delete Route success',
        confirm: 'Are you sure to delete this route?'
      },
      fetchError: 'Failed to fetch route list'
    }
  },
  zh: {
    route: {
      search: {
        title: '查询条件',
        appId: '应用ID',
        serviceName: '接口名称',
        serviceCode: '接口编码',
        placeholder: '请输入服务注册名称'
      },
      list: {
        title: '服务注册'
      },
      dialog: {
        addTitle: '添加服务注册',
        editTitle: '编辑服务注册',
        delTitle: '删除服务注册',
        cancel: '取消',
        confirm: '确定'
      },
      form: {
        id: 'id',
        appId: '应用ID',
        serviceId: '服务ID',
        orderTypeCd: '订单类型',
      },
      table: {
        id: 'id',
        appId: '应用ID',
        serviceId: '服务ID',
        orderTypeCd: '订单类型',
        serviceCode: '接口编码',
        serviceName: '接口名称',
        appName: '应用名称',
      },
      validate: {
        id: '请输入id',
        appId: '请输入应用ID',
        serviceId: '请输入服务ID',
        orderTypeCd: '请输入订单类型',
      },
      register:'注册',
      add: {
        success: '添加服务注册成功'
      },
      edit: {
        success: '编辑服务注册成功'
      },
      delete: {
        success: '删除服务注册成功',
        confirm: '确认删除该服务注册吗？'
      },
      fetchError: '获取服务注册列表失败'
    }
  }
}